import { Icon, ScrollableList } from '@ps/isp-web-component-library';
import type { EventType } from '@ps/isp-web-services-types';
import type { FC } from 'react';
import { useSelector } from 'react-redux';

import { useRegulatoryIntl } from '@swf/core/hooks/useRegulatoryIntl';
import { ariaLabelScrollLeft, ariaLabelScrollRight } from '@swf/sports/utils/getAriaLabels';
import { getEventTypeIcon } from '@swf/sports/utils/getEventTypeIcon';

import { useSportsMenuWidget } from '../../../../../model';

import styles from './SportsPills.scss';

interface Props {
  selectedEventTypeId: EventType;
}

const SportsPills: FC<Props> = ({ selectedEventTypeId }) => {
  const { widgetDispatch, widgetSelect } = useSportsMenuWidget();
  const { uniqueEventTypes } = useSelector(widgetSelect.searchResults);
  const { formatMessage } = useRegulatoryIntl();

  return (
    <ScrollableList
      slotProps={{
        previousButton: {
          'aria-label': formatMessage(ariaLabelScrollLeft)
        },
        nextButton: {
          'aria-label': formatMessage(ariaLabelScrollRight)
        }
      }}
    >
      {uniqueEventTypes.map(({ eventTypeId, name: eventTypeName }) => (
        <ScrollableList.Tab
          key={eventTypeId}
          onClick={() => widgetDispatch.setSelectedEventType(eventTypeId)}
          active={selectedEventTypeId === eventTypeId}
        >
          <span key={eventTypeId} className={styles.textWrapper}>
            <Icon icon={getEventTypeIcon(eventTypeId)} size="x1" className={styles.icon} />
            {eventTypeName}
          </span>
        </ScrollableList.Tab>
      ))}
    </ScrollableList>
  );
};

export default SportsPills;
